@if (state$().visible) {
  <div class="sol-debug-info-actions">
    <sol-button [icon]="SolIcon.delete" [type]="SolButtonType.transparent" (click)="onClear()" />
    <sol-button [icon]="SolIcon.remove" [type]="SolButtonType.transparent" (click)="onClose()" />
  </div>

  @for (group of state$().groups; track group.name) {
    <div class="sol-card-title">{{ group.name }}</div>

    @for (item of group.items; track item.id) {
      <div class="sol-debug-info-item-info" (click)="onToggleLogging(item.id)">
        <sol-icon [name]="item.logEnabled ? SolIcon.switch_on : SolIcon.switch_off" />
      </div>
      <div class="sol-debug-info-item-label" (click)="copyStateToClipboard(item.name, group.name)">
        {{ item.name }}
      </div>
      <div class="sol-debug-info-item-info" (click)="copyToClipboard(item.name, group.name)">
        <sol-icon [name]="SolIcon.info" />
      </div>

      <div class="sol-debug-info-item-chart">
        @for (count of item.counts; track idx; let idx = $index) {
          <div class="sol-debug-info-item-chart-bar" [style]="'height: ' + (count / group.max) * 100 + '%'"></div>
        }
      </div>
      <div class="sol-debug-info-item-count">
        <div>{{ item.max }}</div>
      </div>
    }
  }

  @if (state$().groups.length === 0) {
    <div class="sol-debug-info-empty">No debug info available</div>
  }
}
